export default __webpack_public_path__ + "static/fv-nr-2-addf5a62e44ca5e91bd8df62a40889c0.png";